<template>
      <div>
            <jd-dialog :title="`${type === 'create' ? `添加${titleName}` : `修改${titleName}`}`" :visible.async="visible"
                  width="1010px" @close="taskClose" @comfirm="sureTask">
                  <el-form :model="form" label-width="100px">
                        <el-form-item label="题目类型:" required>
                              <el-radio-group v-model="form.type" @change="changeType">
                                    <el-radio :label="1">单选题</el-radio>
                                    <el-radio :label="4">图片选择题</el-radio>
                              </el-radio-group>
                        </el-form-item>
                        <el-form-item label="题目名称:" required>
                              <el-input type="textarea" style="width: 500px;" placeholder="请输入内容" v-model="form.title"
                                    show-word-limit :maxlength="50">
                              </el-input>
                        </el-form-item>
                        <el-form-item label="题目权重:" required>
                              <el-radio-group v-model="form.questionWeight">
                                    <el-radio :label="1">高权重（硬性约束题）</el-radio>
                                    <el-radio :label="2">中权重（核心需求题）</el-radio>
                                    <el-radio :label="3">低权重（了解偏好题）</el-radio>
                              </el-radio-group>
                        </el-form-item>
                        <el-form-item label="选项设置:" required>
                              <div class="optionSetting">
                                    <div v-for="(item, index) in form.options" :key="index">
                                          <el-form-item :label="`选项${optionTitle(index)}:`" required>
                                                <template v-if="form.type == 1">
                                                      <div>
                                                            <div style="display: flex;align-items: center;">
                                                                  <el-input v-model="item.description"
                                                                        style="width: 500px;" placeholder="请输入"
                                                                        show-word-limit :maxlength="50"></el-input>
                                                                  <jd-button v-if="form.options.length > 2"
                                                                        type="blueText" style="margin-left: 10px;"
                                                                        @click="removeOption(index)">删除</jd-button>
                                                            </div>
                                                            <div v-if="form.questionWeight == 1"
                                                                  style="display: flex;align-items: center;margin-top: 8px;">
                                                                  <span
                                                                        style="margin-right: 5px;color: #666;">适配结论</span>
                                                                  <el-input v-model="item.adaptConclusion"
                                                                        style="width: 440px;" placeholder="请输入"
                                                                        show-word-limit :maxlength="30"></el-input>
                                                            </div>
                                                      </div>
                                                </template>
                                                <template v-if="form.type == 4">
                                                      <div style="display: flex;">
                                                      <el-upload class="upload" action="/jd-hd-web/image/upload"
                                                            :show-file-list="false" :before-upload="beforeUpload"
                                                            :on-success="(res, file, fileList) =>
                                                                  handleUpload(res, file, fileList, index)
                                                                  ">
                                                            <div class="img">
                                                                  <img v-if="item.picUrl" :src="item.picUrl"
                                                                        alt="选项图片" />
                                                                  <img v-else
                                                                        :src="$globalCdn + '/images/select_images.svg'"
                                                                        alt="选择图片" />
                                                            </div>
                                                      </el-upload>
                                                      <div class="dec">
                                                            <div class="dec_text">尺寸建议：200px*200px</div>
                                                            <div class="dec_text">图片大小：2M以内</div>
                                                            <div class="dec_text">支持格式：jpg，png</div>
                                                      </div>
                                                      <jd-button style="margin-left: 8px;" type="blueText" v-if="form.options.length > 2"
                                                                  @click="removeOption(index)">删除</jd-button>
                                                      </div>
                                                </template>
                                          </el-form-item>
                                    </div>
                                    <div>
                                          <jd-button type="blue" size="small" @click="addOption(form.options.length)">
                                                新增选项({{ form.options.length }}/20)
                                          </jd-button>
                                    </div>
                              </div>

                        </el-form-item>
                  </el-form>
            </jd-dialog>
      </div>
</template>
<script>
export default {
      props: {
            type: {
                  type: String,
                  default: 'create',
            },
            titleName: {
                  type: String,
                  default: '题目',
            },
            visible: {
                  type: Boolean,
                  default: false,
            },
            questionData: {
                  type: Object,
                  default: () => {},
            },
      },
      data() {
            const defaultForm = {
                  type: 1,
                  title: '',
                  questionWeight: 1,
                  isMust: 1,
                  options: [
                        { level: 'A', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                        { level: 'B', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                        { level: 'C', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                        // { level: 'D', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null }
                  ],
            }
            return {
                  form: JSON.parse(JSON.stringify(defaultForm)),
                  defaultForm,
            }
      },
      watch: {
            visible(newVal) {
                  if (newVal) {
                        Object.assign(this.form, JSON.parse(JSON.stringify(this.defaultForm)));
                        console.log("edit",this.type,this.questionData,this.form);
                        if (this.type == 'edit') {
                              this.form = {
                                    ...this.form,
                                    ...this.questionData,
                              }
                        }
                  }
            }
      },
      methods: {
            changeType(){
                  // this.form.options = [
                  //       { level: 'A', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                  //       { level: 'B', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                  //       { level: 'C', adaptConclusion: '', description: '', picUrl: '', isInputText: 0, uuid: null },
                  // ];
            },
            async beforeUpload(file) {
                  // 图片上传前的校验
                  let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                  let sorts = [".png", ".jpg"];

                  if (sorts.indexOf(type) < 0) {
                        this.$message.info("图片格式不符合要求，请重新上传");
                        await Promise.reject();
                        return false;
                  }
                  // await this.imgchecked(file, 300, 300);
                  // console.log(file);
                  // const isLt3M = file.size < 1024 * 100;
                  // if (!isLt3M) {
                  //   this.$message.info("图片大小不符合要求，请重新上传");
                  //   await Promise.reject();
                  //   return false;
                  // }
            },
            handleUpload(res, file, fileList, index) {
                  // 上传成功 单个盲盒图
                  if (res.code != 1) {
                        this.$message.error(res.message || "上传失败");
                  } else {
                        console.log("---  res:---", res);
                        // 直接更新指定索引的选项
                        const imageUrl = res.data;
                        if (imageUrl) {
                              this.$set(this.form.options[index], "picUrl", imageUrl);
                        }
                  }
            },
            // 根据 index获取选项名称
            optionTitle(index) {
                  switch (index) {
                        case 0:
                              return "A";
                        case 1:
                              return "B";
                        case 2:
                              return "C";
                        case 3:
                              return "D";
                        case 4:
                              return "E";
                        case 5:
                              return "F";
                        case 6:
                              return "G";
                        case 7:
                              return "H";
                        case 8:
                              return "I";
                        case 9:
                              return "J";
                        case 10:
                              return "K";
                        case 11:
                              return "L";
                        case 12:
                              return "M";
                        case 13:
                              return "N";
                        case 14:
                              return "O";
                        case 15:
                              return "P";
                        case 16:
                              return "Q";
                        case 17:
                              return "R";
                        case 18:
                              return "S";
                        case 19:
                              return "T";
                        case 20:
                              return "U";
                        default:
                              return "";
                  }
            },
            // 新增选项
            addOption(index) {
                  if (this.form.options.length >= 20) {
                        this.$message({
                              message: '最多只能添加20个选项',
                              type: 'warning',
                        });
                        return;
                  }
                  this.form.options.push({
                        level: this.optionTitle(index + 1),
                        adaptConclusion: '',
                        description: '',
                        picUrl: '',
                        isInputText: 0, 
                        uuid: null
                  });
            },
            // 删除选项
            removeOption(index) {
                  this.form.options.splice(index, 1);
            },
            taskClose() {
                  this.$emit('close');
            },
            generateRandomString(length) {
                  let result = "";
                  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
                  const charactersLength = characters.length;
                  for (let i = 0; i < length; i++) {
                        result += characters.charAt(Math.floor(Math.random() * charactersLength));
                  }
                  return result;
            },
            sureTask() {
                  if (!this.form.title) {
                        this.$message({
                              message: '请输入题目名称',
                              type: 'warning',
                        });
                        return;
                  }
                  if (this.form.type == 4) {
                        if (this.form.options.some(item => !item.picUrl)) {
                              this.$message({
                                    message: '请上传选项图片',
                                    type: 'warning',
                              });
                              return;
                        }
                  }
                  if (this.form.type == 1) {
                        if (this.form.options.some(item => !item.adaptConclusion) && this.form.questionWeight == 1) {
                              this.$message({
                                    message: '请填写选项适应结论',
                                    type: 'warning',
                              });
                              return;
                        }
                        if (this.form.options.some(item => !item.description)) {
                              this.$message({
                                    message: '请填写选项描述',
                                    type: 'warning',
                              });
                              return;
                        }
                  }
                  // 生成uuid
                  this.form.options.forEach((item, index) => {
                        item.uuid = item.uuid? item.uuid:this.generateRandomString(10);
                        item.level = this.optionTitle(index);
                  })
                  this.$emit('comfirm', this.form);
            },
      }
}
</script>
<style lang="scss" scoped>
.optionSetting {
      width: 100%;
      background-color: #f8f9fc;
      padding: 20px;
}

.img {
      width: 70px;
      height: 70px;
      margin: 0 12px 0 8px;

      img {
            width: 100%;
            height: 100%;
            cursor: pointer;
      }
}

.dec {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;

      .dec_text {
            line-height: 17px;
            font-size: 12px;
            color: #999;
      }

      span {
            color: #3159ff;
            cursor: pointer;
            line-height: 18px;
      }

      .hidden {
            color: rgba(49, 89, 255, 0.8);
            cursor: not-allowed;
      }
}
</style>